import { Navigate, Outlet } from "react-router-dom";
import { permissions } from "../../roles";
import { useDispatch } from "react-redux";
import { updateShowSidebar } from "../../redux/slices/globalVariableSlice";

const ProtectedRoute = ({ requiredPermission }: any) => {
  const dispatch = useDispatch();
  const role = atob(sessionStorage.getItem("key") || "");
  if (role === "NA") {
    return <Navigate to="/Unauthorised" />;
  }

  if (!permissions[role?.toUpperCase()]?.includes(requiredPermission)) {
    return <Navigate to="/dashboard" />;
  }
    dispatch(updateShowSidebar(true));

  return <Outlet />;
};

export default ProtectedRoute;
